<script>
    import { RepositoryFactory } from "../../src/api/repositories/RepositoryFactory";
    import {mapActions,mapState} from "vuex";
    const NotificationsRepository = RepositoryFactory.get('notifications');

    export default {
        name: "Notifications",
        data () {
            return {
                notificationsIntervalDuration: 180000,
                notificationsTimeoutId: 0,
                notificationsLoaded: false,
                inactivityWatcherInterval: null,
	            secondsSinceLastActivity: 0,
	            secondsBeforeInactive: 60 * 5,
            }
        },
        computed : {
            ...mapState('products',[
                'courses'
            ]),
            ...mapState('pages',[
                'pageContext'
            ]),
            ...mapState(['server']),
            ...mapState('user',[
                'usertoken'
            ])
        },
        mounted(){
            this.$nextTick(()=>{
                //If there is no pageId the page is legacy               
                if(this.pageContext?.params?.id){
                    this.initInactivityWatcher();
                }
            })            
            
        },
        methods: {
            ...mapActions(['syncNotificationsData']),            
            postNotificationsSuccessCallback (data) {
                this.syncNotificationsData(data);               

            },
            isInactive: function () {
                return this.secondsSinceLastActivity > this.secondsBeforeInactive || document.hidden;
            },
            initNotificationsInterval(actionTime, additionalData, how) {
                
                //If there is no pageId the page is legacy
                if(!this.pageContext?.params?.id){
                    return;
                }
                let postData = {
                    'page': this.pageContext?.type,
                    'pageId': this.pageContext.params.id,
                    'pageUrl': window.location.pathname + window.location.search,
                    'context': [],//this.context,
                    'me':!this.notificationsLoaded,
                    'inactive': this.isInactive()
                };

                if (actionTime)
                    postData['actionTime'] = actionTime;

                if(typeof additionalData != 'undefined' && additionalData !== null ){
                    postData['additionalData'] = additionalData;
                }
                var async = (['onUnload'].indexOf(how) < 0);

                if (!async && typeof navigator.sendBeacon !== "undefined") {
                    var data = JSON.stringify(postData);
                    var form = new FormData();
                    form.append('data', data);
                    form.append('_token', this.usertoken);
                    navigator.sendBeacon(this.server + "notifications", form);
                    return;
                }

                NotificationsRepository.postNotifications(postData).then( response => {
                    if (response.data && response.data.success) {
                        this.postNotificationsSuccessCallback(response.data);
                        if(response.data.me){
                            this.syncLegacyVars(response.data.me);
                        }                        
                        this.notificationsLoaded = true;
                    }
                });

                this.notificationsTimeoutId = window.setTimeout( () => {
                    this.initNotificationsInterval();
                },this.notificationsIntervalDuration);

                return;

                // var async = (['onUnload'].indexOf(how) < 0);

                // if (!additionalData) {
                //     additionalData = null;
                // }

                // $.ajax({
                //     //url: server+"notifications/"+this.context[this.context.length-1],
                //     url: server+"notifications",
                //     data:'data='+encodeURIComponent(JSON.stringify(postData)),
                //     dataType: "json",
                //     type: 'POST',
                //     //type: 'GET',
                //     headers:{"authuser":usertoken},
                //     async: async,
                //     success: function(data, textStatus, xhr) {

                //         _this.data = data.data;
                //         _this.refresh = true;
                //         _this.updateLeftBar()
                //         if (!_this.notificationsLoaded && data.me){
                //             var temp=me.meli, temp2=me.subscribed, temp3=me.subscription;
                //             data.me.courses = [];
                //             // if (data.userCourses){
                //             $.each(data.userCourses, function(i, v) {
                //                 data.me.courses[i] = data.courses[v.courseId];
                //                 data.me.courses[i].me = v.me;
                //             });
                //             // }
                //             me=data.me;
                //             if (data.support) { _this.support  = data.support; +_this.bindContacts()}

                //             if (data.coursesTags) _this.coursesTags = data.coursesTags;
                //             //if (data.coursesSubscriptions) _this.coursesSubscriptions = data.coursesSubscriptions;

                //             me.meli=temp;
                //             me.subscribed = temp2;
                //             // me.subscription = temp3;

                //             if(typeof subscriptionMode != "undefined" && subscriptionMode == true &&
                //                 typeof me != "undefined" && (me.subscription != false || data.trialExpired == true ) ){
                //                 if(me.subscription.on_trial == true || data.trialExpired ){

                //                     var days = me.subscription.trial_days_left;
                //                     var objectToRender = {
                //                         'days_left' : days,
                //                         'on_trial' : me.subscription.on_trial,
                //                     }

                //                     var notificationWrapper = $($("#trialExpirationNotification").render(objectToRender)).prependTo($("#topBarWrapper").find(".-basic-functions"));
                //                     $(notificationWrapper).find('.close').click(function(e){
                //                         $(notificationWrapper).addClass('to-hide');
                //                     });

                //                 }
                //             }
                //             _this.navpanel = new navpanel();
                //             _this.showAds();

                //             if (typeof data.instructors !== 'undefined') {
                //                 var ul = '<ul class="-hamburger-user-choices -instructor-hamburger-user-choices">';
                //                 var ul2 = '<ul class="user-menu instructors-submenu custom-clr1-bg">';

                //                 $.each(data.instructors, function (i, v) {
                //                     ul += '<li class="hamburger-bar-button" onclick="topBar.inbox(\'' + v.id + '\', \'' + v.username + '\')"><span class="bar-button-label custom-clr11-text ellipsis-text">' + v.username +'</span></li>'
                //                     ul2 += '<li class="user-menu-choice clr2-bg-hover custom-clr11-text" onclick="topBar.inbox(\'' + v.id + '\', \'' + v.username + '\')">' + v.username +'</li>';
                //                 });

                //                 ul += '</ul>';
                //                 ul2 += '</ul>';

                //                 $('#hamburgerSideNav').find('.js-instructors-topbar').find('.js-instructors-topbar-choices').replaceWith($(ul));
                //                 $('#userMenu').find('.js-instructors-topbar').find('.js-instructors-topbar-choices').replaceWith($(ul2));
                //                 $('.js-instructors-topbar').show();
                //                 $('.js-instructor-topbar').hide();
                //             }

                //             _this.notificationsLoaded=true;

                //             if (!isLoadedInIframe('learnworlds') || (isLoadedInIframe('learnworlds') && window.parent.location.pathname.indexOf("/author/pages_preview") !== 0)) {

                //                 //Update Data Protection User Settings
                //                 if(typeof window.dpModalRenderer != 'undefined'){
                //                     window.dpModalRenderer.syncDataProtectionData();
                //                 }
                //                 if(typeof window.marketingOptInModalRenderer != 'undefined'){
                //                     if(window.marketingOptInModalRenderer.shouldInit()){
                //                         window.marketingOptInModalRenderer.init();
                //                     }
                //                 }
                //             }

                //             if(_this.initCallback)
                //                 _this.initCallback();

                //         }
                //         //window.setTimeout($.proxy(_this.updateLeftBar, _this), 3000);
                //     },
                //     error: function(xhr, textStatus, errorThrown) {
                //         //	alert("Top bar data not loaded")
                //     }
                // });


            },
            syncLegacyVars(meData){
                //update window me var in order to sync dp data
                window.me = {
                    ...window.me,
                    ...meData
                };

                if (!window.isLoadedInIframe('learnworlds')){
                    
                    
                    //Update Data Protection User Settings
                    if(typeof window.dpModalRenderer != 'undefined'){
                        window.dpModalRenderer.syncDataProtectionData();
                    }
                    if(typeof window.marketingOptInModalRenderer != 'undefined'){
                        if(window.marketingOptInModalRenderer.shouldInit()){
                            window.marketingOptInModalRenderer.init();
                        }
                    }
                }
            },
            initInactivityWatcher(){                
                // If watcher has already started then we should restart it
                if (this.inactivityWatcherInterval) {
                    console.warn('Inactivity watcher has already started, restarting.');
                    this.stopInactivityWatcher();
                }

                const checkEvery = 1; // seconds
                //Setup the setInterval method to run
                //every second. 1000 milliseconds = 1 second.
                this.inactivityWatcherInterval = window.setInterval(()=>{
                    this.secondsSinceLastActivity += checkEvery;                    
                    //if the user has been inactive or idle for longer
                    //then the seconds specified in maxInactivity
                    if(this.secondsSinceLastActivity > this.secondsBeforeInactive){
                        // console.log('User has been inactive for more than ' +  this.secondsBeforeInactive + ' seconds');
                    }
                }, checkEvery * 1000);

                this.inactivityHandler();
            },
            inactivityHandler(documentOvveride){                
                const doc = documentOvveride || document;
                //An array of DOM events that should be interpreted as
                //user activity.
                const activityEvents = [
                    'mousedown', 'mousemove', 'keydown',
                    'scroll', 'touchstart'
                ];

                // TODO replace with debounce
                var debounce = function(func, wait) {
                    let timeout;
                    return function() {
                        const context = this, args = arguments;
                        var later = function() {
                            timeout = null;
                            func.apply(context, args);
                        };
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                    };
                };

                //add these events to the document.
                //register the activity function as the listener parameter.
                activityEvents.forEach(eventName=>{
                    doc.addEventListener(eventName, debounce($.proxy(this.resetInactivityWatcherTimer, this), 100, true), true);
                });
            },
            stopInactivityWatcher: function () {
              
                if (this.inactivityWatcherInterval) {
                    window.clearInterval(this.inactivityWatcherInterval);
                }

                //An array of DOM events that should be interpreted as
                //user activity.
                const activityEvents = [
                    'mousedown', 'mousemove', 'keydown',
                    'scroll', 'touchstart'
                ];

                activityEvents.forEach(function(eventName) {
                    document.removeEventListener(eventName, this.resetInactivityWatcherTimer, true);
                });

                // Reset
                this.resetInactivityWatcherTimer();
            },
            resetInactivityWatcherTimer: function() {
                this.secondsSinceLastActivity = 0;
            }
        }
    }
</script>

